import { REGISTRATION_STEPS } from 'constants/auth'
import { USER_STATUSES } from 'constants/user'

export const getSignInStep = userData => {
  if (!userData) {
    return REGISTRATION_STEPS.create
  }

  if (!userData.shippingAddress
      || (!userData.creditCard || (userData.creditCard && !userData.creditCard.billingAddress
      && userData.creditCard.isAdditionalProtectionRequired))
  ) {
    return REGISTRATION_STEPS.payment
  }

  if (userData.shippingAddress
    && userData.creditCard
    && !userData.subscription.termsAccepted
  ) {
    return REGISTRATION_STEPS.terms
  }

  if (userData.subscription.termsAccepted) {
    return REGISTRATION_STEPS.congrats
  }
}

export const getCurrencySymbol = currency => {
  // if (!currency) return '$'

    // cases will be populated in case of adding new currencies
  // if (currency === 'USD') {
  //   return '$'
  // }
  return '$'
}

export const getPostalCodeFormatted = (postalCode: string) => {
  if (postalCode.length > 5) {
    return `${postalCode.slice(0, 5)}-${postalCode.slice(5)}`
  }
  return postalCode
}
